export default function useSleep() {
  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  return {
    sleep
  }
}